import { useState } from "react";

import CustomSelect from "../../../../../Components/common/CustomSelect/CustomSelect";

import { AGENT_OS_OPTIONS, DEFAULT_AGENT_OS } from "../../../../../utils/constants/agentOs";

import "./styles.scss";

// Asks which operating system the installer / collector should be
// downloaded for, then hands the selected os id back to the caller.
const AgentOsPopup = ({ title, description, confirmText = "Download", setShow, onConfirm }) => {
  const [selectedOs, setSelectedOs] = useState(DEFAULT_AGENT_OS);

  const confirmHandler = () => {
    onConfirm(selectedOs.id);
    setShow(false);
  };

  return (
    <div className="popup-form-backdrop" onClick={() => setShow(false)}>
      <div onClick={(e) => e.stopPropagation()}>
        <div className="popup-form">
          <h3 className="popup-form__article">{title}</h3>
          <p className="popup-form__description">{description}</p>

          <div className="popup-form__os-select">
            <p className="popup-form__os-select__label">Operating System</p>
            <CustomSelect
              width="240px"
              height="40px"
              data={AGENT_OS_OPTIONS}
              select={selectedOs}
              setSelected={setSelectedOs}
            />
          </div>

          <div className="flex">
            <button className="primary-button popup-form__wide-button" onClick={confirmHandler}>
              {confirmText}
            </button>
            <button className="danger-button" onClick={() => setShow(false)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentOsPopup;
